import React from 'react';
import { SingleCommonType } from '../../types';
import { freePlayedPlaceholder } from '../../constants/placeholder';
import CommonSingleSelect from '../../components/CommonSingleSelect';
import { refundedOptions } from '../../constants/refunded';
import { FilterButtonPoint } from '@op/operationLog/pages/filter';

export default function FreePlayedSelect(props: SingleCommonType) {
  return (
    <CommonSingleSelect
      {...props}
      returnKey="free_played"
      dealwithReturnValue={(value) => Number(value)}
      singlePlaceholder={freePlayedPlaceholder}
      options={refundedOptions}
      pointKey={FilterButtonPoint.freePlayed}
      initValue="0"
    />
  );
}
